import { createAsyncThunk } from '@reduxjs/toolkit';
import QueryString from 'qs';
import ApiaApi, { makeApiaUrl } from '../../../../../api/apiaApi/apiaApi';
import { arrayOrArray } from '../../../../../utils/util';
import store, { TRootState } from '../../../..';
import { TApiaFilter, TApiaFunction, TApiaLoad } from '../../../../../types';
import { TResponsiveTableRow } from '../../../../../components/common/generic/responsiveTable/types';
import { parseRows } from '../../util/rowsParser';
import { buttonsActions } from '../../../../buttonsSlice';
import { TListRowsStructure } from '../../../types';
import { listActions } from '../../..';
import notifyRequiredFilters from '../../util/notifyRequiredFilters';
import { notify } from '../../../../../components/common/notifications/util';

export type TTableRows = {
  rows: TResponsiveTableRow[];
};

const filterTasks = createAsyncThunk<
  TListRowsStructure & {
    filters?: TApiaFilter[] | undefined;
  },
  {
    listId: string;
    filters?: TApiaFilter[];
    referencingFilterId: string;
  },
  { state: TRootState }
>(
  'listSlice/filterTskMonTasks',
  async ({ listId, filters, referencingFilterId }, thunkApi) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );

    const state = thunkApi.getState().listSlice.lists[listId];
    const { dispatch } = thunkApi;
    /**
     * La siguiente logica se encarga de detecctar si todos los filtros
     * requeridos fueron ingresados. De ser asi o si no hay filtros requeridos,
     * isRequirementSet deberia cambiar a true
     */
    let isRequirementSet = false;
    let required = 0;
    let withValue = 0;

    if (filters) {
      state.filters?.forEach((innerFilter) => {
        if (
          !filters.find(
            (incommingfilter) => incommingfilter.id === innerFilter.id,
          )
        ) {
          if (innerFilter.required) {
            required++;
            if (innerFilter.currentValue) {
              withValue++;
            }
          }
        }
      });
      filters.forEach((innerFilter) => {
        if (innerFilter.required) {
          required++;
          if (innerFilter.currentValue) {
            withValue++;
          }
        }
      });
    }

    if (required === withValue) isRequirementSet = true;

    /**
     * La siguiente logica se encarga de guardar en newFilters cada filtro en
     * el estado con los cambios de valor realizados
     */

    const newFilters = filters
      ? state.filters?.map((currentFilter) => {
          const updatingFilter: TApiaFilter | undefined = filters.find(
            (searchFilter) => {
              if (
                ['date', 'D'].includes(searchFilter.type as string) &&
                ['date', 'D'].includes(currentFilter.type as string)
              ) {
                if (searchFilter.id === currentFilter.filterToId) {
                  return searchFilter.id === currentFilter.filterToId;
                }
                return searchFilter.id === currentFilter.id;
              }

              return searchFilter.id === currentFilter.id;
            },
          );

          if (updatingFilter) {
            if (
              ['date', 'D'].includes(currentFilter.type as string) &&
              updatingFilter.id === currentFilter.filterToId
            ) {
              updatingFilter.id = currentFilter.id;
              updatingFilter.filterToValue = updatingFilter.currentValue;
              updatingFilter.currentValue = currentFilter.currentValue;
            } else if (
              updatingFilter.options &&
              !(
                [
                  'processesAdHocControl',
                  'processesAdHocControl',
                  'processFinalizeControl',
                  'processPriorityControl',
                  'processReasignControl',
                  'processesRollbackControl',
                  'processChangeDateControl',
                ].includes(window.listData[listId].component) &&
                updatingFilter.id === 'cmbSta'
              )
            ) {
              updatingFilter.options = updatingFilter.options.map((option) => {
                if (updatingFilter.currentValue === option.value) {
                  return {
                    ...option,
                    selected: true,
                  };
                }
                return {
                  ...option,
                  selected: false,
                };
              });
            }

            return { ...currentFilter, ...updatingFilter };
          }

          return currentFilter;
        })
      : state.filters;

    /**
     * La siguiente logica se encarga de armar el payload que se enviara para
     * settear los filtros en el bean
     */

    const payloadFilters: Record<string, unknown> = {
      back: false, 
      proId: newFilters?.find(f=>f.id ==='txtProTitle')!== undefined 
                ? newFilters?.find(f=>f.id ==='txtProTitle')?.options?.find(o=>o.selected)?.value
                :'',
      proNameAux:newFilters?.find(f=>f.id ==='txtProTitle')!== undefined 
                ? newFilters?.find(f=>f.id ==='txtProTitle')?.options?.find(o=>o.selected)?.label 
                :'',
    };

    newFilters?.forEach((currentFilter) => {
      if(currentFilter.id !== 'txtProTitle'){
        payloadFilters[`${currentFilter.id}`] = currentFilter.currentValue;
      }

      if (currentFilter.options) {
        currentFilter.options.forEach((option) => {
          if (option.selected) {
            if(currentFilter.id !== 'txtProTitle'){
              payloadFilters[`${currentFilter.id}`] = option.value;
            }
          }
        });
      }
      if (['date', 'D'].includes(currentFilter.type as string)) {
        payloadFilters[`${currentFilter.filterToId as string}`] =
          currentFilter.filterToValue;
      }
    });

    if (
      ['tasksChangeDateControl'].includes(
        window.listData.tasksMonitor.component,
      )
    ) {
      payloadFilters.back = false;
      const referencingFilter =
        state.filters?.[
          state.filters?.findIndex(
            (filter) => filter.id.toString() === referencingFilterId,
          )
        ];
      const referencingFilterProId = referencingFilter?.options?.filter(
        (option) => {
          return option.value === referencingFilter?.currentValue;
        },
      )?.[0]?.id;

      const incommingFilterProId =
        referencingFilterProId ||
        referencingFilter?.options?.filter((option) => {
          return option.value === filters?.[0].currentValue;
        })?.[0]?.id;

      const referencingFilterName = referencingFilter?.options?.filter(
        (option) => {
          return option.value === referencingFilter?.currentValue;
        },
      )?.[0]?.name;

      const incommingFilterName =
        referencingFilterName ||
        referencingFilter?.options?.filter((option) => {
          return option.value === filters?.[0].currentValue;
        })?.[0]?.name;
      payloadFilters.proId = incommingFilterProId;
      payloadFilters.proNameAux = incommingFilterName;
    }

    if (isRequirementSet) {
      const makeApiaPayload: Record<string, unknown> = {
        action: 'filterTasks',
        preventAsXmlParameter: true,
        isAjax: true,
        ajaxUrl: window.listData.tasksMonitor.ajaxUrl
      };
      if (referencingFilterId === filters?.[0].id) {
        makeApiaPayload.timestamp = Date.now();
      }
      const result = await ApiaApi.post<TApiaLoad<TApiaFunction>>(
        makeApiaUrl(makeApiaPayload),
        {
          postData: QueryString.stringify(payloadFilters),
        },
      );
      store.dispatch(
        buttonsActions.updateAction([
          {
            performing: false,
            action: 'disableTable',
          },
        ]),
      );
      if (result && result.data) {
        return {
          rows: parseRows(
            listId,
            arrayOrArray(result.data.function.messages.result.table?.row),
          ),
          pageInfo: result.data.function.messages.result.pageInfo,
          filters: newFilters,
        };
      }
    } else {
      store.dispatch(
        buttonsActions.updateAction([
          {
            performing: false,
            action: 'disableTable',
          },
        ]),
      );
      notify({
        message: `${window.MSG_FILTER_REQUIRED}`,
        type: 'warning',
      });
      void dispatch(
        listActions.setState({
          listId,
          rows: [],
          filters: notifyRequiredFilters(listId, newFilters),
        }),
      );
      return {
        rows: [],
        filters: newFilters,
      };
    }

    throw new Error();
  },
);

export default filterTasks;
